export enum FILTER_KEYS {
  ALL = 'filters',
  ALL_ANALYTICS = 'analytics-filters',
}
